import cs from "classnames";

import type { StackProps } from "@braintrust/braintrust-ui-components";
import { Stack } from "@braintrust/braintrust-ui-components";

import styles from "./styles.module.scss";

type MessengerContentContainerProps = StackProps;

export const MessengerContentContainer = ({
  children,
  className,
  ...rest
}: MessengerContentContainerProps) => {
  return (
    <Stack {...rest} className={cs(styles.messengerContent, className)}>
      {children}
    </Stack>
  );
};
